// @flow
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

export const numbers = '0123456789';
export const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
export const specialCharacters = "!'^+%&/()=?_#$½§{[]}|;:>÷`<.*-@é";

type PasswordGeneratorProps = {
	value: string,
	autoGenerateOnMount?: boolean,
	onChange: () => void,
	passwordLength: number,
	includeUppercase: boolean,
	includeLowercase: boolean,
	includeNumbers: boolean,
	includeSymbols: boolean,
};

type PasswordGeneratorState = {
	password: string,
};

export class PasswordGenerator extends React.Component<PasswordGeneratorProps, PasswordGeneratorState> {
	static defaultProps = {
		autoGenerateOnMount: true,
		passwordLength: 8,
		includeLowercase: true,
	};

	componentDidMount(): void {
		const {autoGenerateOnMount} = this.props;
		if (autoGenerateOnMount) {
			this.handleGeneratePassword();
		}
	}

	render() {
		const { value } = this.props;
		return (
			<div>
				<TextField onChange={this.handleChange} hintText="Пароль" floatingLabelText="Пароль" type="text" value={value} fullWidth={true} floatingLabelFixed />
				<RaisedButton label="сгенерировать новый" onClick={this.handleGeneratePassword} />
			</div>
		);
	}

	handleChange = (value) => {
		const { onChange } = this.props;
		onChange(value);
	}

	handleGeneratePassword = () => {
		const { includeLowercase, includeUppercase, includeNumbers, includeSymbols, onChange } = this.props;
		let characterList = '';

		if (includeLowercase) {
			characterList = characterList + lowerCaseLetters;
		}

		if (includeUppercase) {
			characterList = characterList + upperCaseLetters;
		}

		if (includeNumbers) {
			characterList = characterList + numbers;
		}

		if (includeSymbols) {
			characterList = characterList + specialCharacters;
		}
		const password = this.createPassword(characterList);
		if (onChange) {
			onChange(password);
		}
	};

	createPassword = characterList => {
		const { passwordLength } = this.props;
		let password = '';
		const characterListLength = characterList.length;

		for (let i = 0; i < passwordLength; i++) {
			const characterIndex = Math.round(Math.random() * characterListLength);
			password = password + characterList.charAt(characterIndex);
		}
		return password;
	};
}



// WEBPACK FOOTER //
// src/components/password-generator/password-generator.js